import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import * as FormActions from '../../../reducers/actions/forms.actions';
import { MatDialog, MatSnackBar } from "@angular/material";
import { PerfilComponent } from "../../perfil/perfil.component";
import { Form } from '../../../models/form.model';
import { GLOBAL } from "src/app/services/global";
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from "@angular/forms";
import { RutValidator } from "ng2-rut";
import { PropiedadService } from "src/app/services/propiedad.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ErrorStateMatcher } from '@angular/material/core';

interface AppState {
    form: Form;
}
declare const swal: any;

@Component({
    selector: 'app-ingreso-ascensores',
    templateUrl: './ingreso-ascensores.component.html',
    styleUrls: ['./ingreso-ascensores.component.css'],
    providers: [PropiedadService]
})


export class IngresoAscensoresComponent implements OnInit {
    //info login
    identity;
    token;

    //info footer
    public footer = GLOBAL.footer;
    public name = GLOBAL.name;
    public dire = GLOBAL.dire;
    public phone = GLOBAL.phone;

    //forms
    formularioBusqueda: FormGroup;
    formularioIngreso: FormGroup;
    formularioPersonas: FormGroup;

    //opciones filtradas
    calles: string[] = [];
    filteredCalles: string[] = [];

    //banderas
    step = 'adjuntos';

    //tabla de adjuntos
    public rows = [
        { id: 0, name: "Plano general de ascensores.", archivo: "-", new: false, required: true, estado: "Pendiente" },
        { id: 1, name: "Plano mecánico y específicaciones técnicas de cada instalación.", archivo: "-", new: false, required: true, estado: "Pendiente" },
        { id: 2, name: "Plano instalación eléctrica y plano eléctrico de la línea de seguridad.", archivo: "-", new: false, required: true, estado: "Pendiente" },
        { id: 3, name: "Plano anual de mantención.", archivo: "-", new: false, required: true, estado: "Pendiente" },
        { id: 4, name: "Manual de procedimiento de inspección de cada instalación.", archivo: "-", new: false, required: true, estado: "Pendiente" },
        { id: 5, name: "Manual de uso de instrucciones de rescate, proporcionado por el fabricante o el instalador.", archivo: "-", new: false, required: true, estado: "Pendiente" },
        { id: 6, name: "Certificado de inscripción vigente del mantenedor, del registro de la Ley N. 20.296.", archivo: "-", new: false, required: true, estado: "Pendiente" },
        { id: 7, name: "Certificado de mantención de las instalaciones, emitido por un certificador inscrito en el MINVU.", archivo: "-", new: false, required: true, estado: "Pendiente" },
        { id: 8, name: "Certificado de inscripción vigente del certificador, inscrito en el MINVU.", archivo: "-", new: false, required: true, estado: "Pendiente" },
    ]
    public files = []
    public nombreArchivo;
    public pase = false

    constructor(
        private _fb: FormBuilder,
        private rutValidator: RutValidator,
        private store: Store<AppState>,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private _PropiedadService: PropiedadService,
        private spinner: NgxSpinnerService
    ) {

        this.traerCalles()

        this.formularioBusqueda = this._fb.group({
            rut_sol: ["", [Validators.required, this.rutValidator]],
            calle_sol: ["", [Validators.required,]],
            num_sol: ["", [Validators.required,]]
        })

        this.formularioIngreso = this._fb.group({
            folio_asc: ["", [Validators.required]],
            id_asc: [""],
            destino_asc: ["", [Validators.required]],
            tipo_asc: ["", [Validators.required]],
            permiso_asc: [""],
            fechaPermiso_asc: [""],
            recepcion_asc: ["", [Validators.required]],
            numeroRecepcion_asc: ["", [Validators.required]],
            fechaRecepcion_asc: ["", [Validators.required]],
            fechaCertificado_asc: ["", [Validators.required]],
            fechaProximoCertificado_asc: ["", [Validators.required]]
        })

        this.formularioPersonas = this._fb.group({
            rut_propietario: ["", [Validators.required, this.rutValidator]],
            nombre_propietario: ["", [Validators.required]],
            apP_propietario: ["", [Validators.required]],
            apM_propietario: ["", [Validators.required]],

            rut_instalador: ["", [this.rutValidator]],
            nombre_instalador: [""],
            apP_instalador: [""],
            apM_instalador: [""],

            rut_mantenedor: ["", [Validators.required, this.rutValidator]],
            nombre_mantenedor: ["", [Validators.required]],
            apP_mantenedor: ["", [Validators.required]],
            apM_mantenedor: ["", [Validators.required]],

            rut_certificador: ["", [Validators.required, this.rutValidator]],
            nombre_certificador: ["", [Validators.required]],
            apP_certificador: ["", [Validators.required]],
            apM_certificador: ["", [Validators.required]],

            rut_tecnico: ["", [this.rutValidator]],
            nombre_tecnico: [""],
            apP_tecnico: [""],
            apM_tecnico: [""],
        })


    }



    ngOnInit(): void {
        this.filteredCalles = this.calles;

        const calleControl = this.formularioBusqueda.get('calle_sol');
        if (calleControl) {
            calleControl.valueChanges.subscribe(value => {
                this.filteredCalles = this._filter(value || '');
            });
        }
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.calles.filter(option =>
            option.toLowerCase().includes(filterValue)
        );
    }

    traerCalles() {

        this._PropiedadService.traerCalles().subscribe(data => {
            console.log("calles", data);
            this.calles = data.calles;

            this.filteredCalles = this.calles;
        }, error => {
            console.log(error)
        })
    }

    aceptar(value) {
        switch (value) {
            case 'buscando':
                this.spinner.show();
                console.log(this.formularioBusqueda);
                this._PropiedadService.getPropiedadESRI(undefined, undefined, this.formularioBusqueda.controls.calle_sol.value.trim(), this.formularioBusqueda.controls.num_sol.value.trim()).subscribe(
                    response => {
                        console.log("response", response);
                        this.spinner.hide();
                        if (response) {
                            if (response.status == "error") {
                                alert("No se logró encontrar la dirección ingresada")
                                this.step = "ingreso"
                                /*  swal({
                                     type: 'warning',
                                     title: 'Dirección no encontrada',
                                     text: 'No se logró encontrar la dirección ingresada, para poder continuar favor de revisar que los datos ingresados sean los correctos.',
                                     confirmButtonColor: '#3F51B5',
                                     confirmButtonText: 'Aceptar',
                                 }) */


                            } else {
                                this.step = "ingreso"
                            }
                        }
                    });
                break;
            case 'ingreso':
                this.step = "personas"
                break;

            case 'personas':
                this.step = "adjuntos"
                break;
            case 'adjuntos':
                alert("todos los datos se subieron")
                break;


            default:
                break;
        }

    }

    volver(value) {
        this.step = value
        /*   switch (value) {
              case 'busqueda':
                  this.step = "buscando"
                   this.formularioBusqueda.controls.rut_sol.setValue("")
                   this.formularioBusqueda.controls.calle_sol.setValue("")
                   this.formularioBusqueda.controls.num_sol.setValue("")
                  break;
              default:
                  break;
          } */
    }


    subiendoFileInTable(files: FileList, row) {
        let file: File
        file = files.item(0)

        if (row.id || row.id == 0) {
            for (let index = 0; index < this.rows.length; index++) {
                if (this.rows[index].id == row.id) {
                    this.nombreArchivo = files.item(0).name
                    this.rows[index].archivo = this.nombreArchivo
                    this.rows[index].new = false
                    this.files[index] = ({ name: this.rows[index].name, doc: file })

                }
            }
        }
        this.rows = [...this.rows];
        this.revisarTabla()
        console.log("Archivo cargado", this.files);

    }

    deleteFile(index = null) {
        if (index != null) {
            let fil: File
            fil = this.files[index].doc
            this.files.splice(index, 1)
            this.rows.splice(index, 1)
        } else {
            let fil: File
            fil = this.files[this.files.length - 1].doc
            this.files.splice(this.files.length - 1, 1)
            this.rows.splice(this.rows.length - 1, 1)
        }
    }


    revisarTabla() {
        var bandera = true
        for (let tabla = 0; tabla < this.rows.length; tabla++) {

            if (!this.rows[tabla].archivo || this.rows[tabla].archivo == "") {
                bandera = false
            }

            if ((tabla + 1) == this.rows.length) {
                if (bandera == true) {
                    this.pase = true
                }
            }
        }
    }

    logout() {
        this.store.dispatch(new FormActions.FormUpdate('0', ''))
        sessionStorage.removeItem("identity-domCloud");
        sessionStorage.removeItem("token-domCloud");
        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
            duration: 3000,
        });
    }

    openPerfil() {
        this.dialog.open(PerfilComponent)
    }

}